<template>
  <div id="Timer">{{ time }}</div>
</template>

<script>
export default {
  name: "Timer",
  components: {},
  props: {
    roundStartTime: {
      type: String,
      default: () => "",
    },
    // width: {
    //   type: Number,
    //   default: () => 182,
    // },
    // height: {
    //   type: Number,
    //   default: () => 29,
    // },
    // style: {
    //   type: String,
    //   default: () =>
    //     "bottom: 82px; left: 176px; width: 180px; height: 27px; border: 1px solid black;",
    // },
    // sendImg: {
    //   type: Boolean,
    //   default: () => false,
    // },
  },
  watch: {
    roundStartTime: function (newVal) {
      console.log(newVal);
      this.start(newVal);
    },
  },
  data() {
    return {
      time: "00:00:00.000",
      timeBegan: null,
      started: null,
      running: false,
      stoppedDuration: 0,
    };
  },

  methods: {
    start(time) {
      console.log(time);
      // if (this.running) return;
      this.reset();
      if (time) {
        this.timeBegan = new Date(time);
        // console.log("TES");
      } else {
        this.timeBegan = new Date();
      }

      // if (this.timeStopped !== null) {
      //   this.stoppedDuration += new Date() - this.timeStopped;
      // }

      this.started = setInterval(this.clockRunning, 10);
      this.running = true;
    },
    // stop() {
    //   this.running = false;
    //   this.timeStopped = new Date();
    //   clearInterval(this.started);
    // },
    reset() {
      this.running = false;
      clearInterval(this.started);
      this.stoppedDuration = 0;
      this.timeBegan = null;
      this.timeStopped = null;
      this.time = "00:00:00.000";
    },
    clockRunning() {
      var currentTime = new Date();
      // console.log(this.timeBegan);
      // console.log(currentTime - this.timeBegan);

      var timeElapsed = new Date(
          currentTime - this.timeBegan - this.stoppedDuration
        ),
        hour = timeElapsed.getUTCHours(),
        min = timeElapsed.getUTCMinutes(),
        sec = timeElapsed.getUTCSeconds();

      this.time =
        this.zeroPrefix(hour, 2) +
        ":" +
        this.zeroPrefix(min, 2) +
        ":" +
        this.zeroPrefix(sec, 2);
    },
    zeroPrefix(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
  },
  created() {
    console.log(this.roundStartTime);
    this.start(this.roundStartTime);
  },
};
</script>

<style scoped>
#Timer {
  background: white;
  border-radius: 5px;
  font-size: 1.6em;
  margin: 0 auto;
  text-align: center;
}
</style>
